module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/uterus-f493c4c26c9ad4956c631b03a77f35e2.png";